"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardWrapper = void 0;
exports["default"] = RecordCard;

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ImageRounded2 = _interopRequireDefault(require("@material-ui/icons/ImageRounded"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _styles = require("@material-ui/styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _formatters = require("../formatters");

var _icons = _interopRequireDefault(require("../icons"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CardWrapper = (0, _styles.withStyles)(function () {
  return {
    root: {
      width: "100%",
      height: "100%",
      minHeight: 100,
      border: "2px solid #f2f2f2",
      borderRadius: 6,
      backgroundColor: "white",
      overflow: "hidden",
      cursor: "pointer"
    }
  };
})(_Box2["default"]);
exports.CardWrapper = CardWrapper;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    title: {
      fontWeight: 600,
      fontSize: 18
    },
    labelWrapper: {
      marginBottom: 2,
      "& svg": {
        fontSize: 16,
        marginRight: 6,
        color: theme.palette.text.secondary
      }
    },
    value: {
      textOverflow: "ellipsis",
      overflow: "hidden",
      width: "100%",
      lineClamp: 1,
      display: "-webkit-box",
      boxOrient: "vertical"
    },
    item: {
      width: "100%",
      height: 55,
      overflow: "hidden"
    }
  };
});
RecordCard.propTypes = {
  isPlaceholder: _propTypes["default"].bool,
  onClick: _propTypes["default"].string,
  coverFieldId: _propTypes["default"].string,
  record: _propTypes["default"].object,
  fields: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    name: _propTypes["default"].string,
    type: _propTypes["default"].string,
    options: _propTypes["default"].object
  }))
};
RecordCard.defaultProps = {
  fields: []
};

function RecordCard(_ref) {
  var coverFieldId = _ref.coverFieldId,
      fields = _ref.fields,
      record = _ref.record,
      _onClick = _ref.onClick,
      isPlaceholder = _ref.isPlaceholder;
  var classes = useStyles();
  var data = (0, _react.useMemo)(function () {
    return isPlaceholder ? {} : record || {};
  }, [record, isPlaceholder]);
  var getFieldAttachment = fields.find(function (item) {
    return item.type === "attachment";
  });
  var getFields = fields.filter(function (item) {
    return item.type !== "attachment" && item.name !== "name";
  });
  var getFieldName = fields.find(function (item) {
    return item.name === "name";
  });
  var getFieldCover = fields.find(function (item) {
    return item.id === coverFieldId;
  });
  var cover = (0, _react.useMemo)(function () {
    if (getFieldCover) {
      return Array.isArray(data[getFieldCover.name]) && data[getFieldCover.name][0] ? data[getFieldCover.name][0] : "empty";
    }

    if (getFieldAttachment) {
      return data[getFieldAttachment.name] && data[getFieldAttachment.name][0] ? data[getFieldAttachment.name][0] : "empty";
    }

    return null;
  }, [getFieldAttachment, getFieldCover, data]);
  return /*#__PURE__*/_react["default"].createElement(CardWrapper, {
    onClick: function onClick() {
      return _onClick(record);
    }
  }, cover && /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderBottom: "1px solid #f2f2f2",
    height: 140
  }, isPlaceholder || cover === "empty" ? /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    textAlign: "center",
    pt: 2
  }, /*#__PURE__*/_react["default"].createElement(_ImageRounded2["default"], {
    style: {
      fontSize: 110,
      color: "#f0f0f0"
    }
  })) : /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      maxWidth: "100%",
      maxHeight: "100%"
    },
    src: cover.url,
    alt: "cover"
  })), /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    p: 2
  }, getFieldName && /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    className: classes.title,
    variant: "subtitle1"
  }, isPlaceholder ? "-" : data.name || "Unnamed"), getFields.map(function (item) {
    var Format = (0, _formatters.getFormatter)(item.type);
    var value = data[item.name];
    item.key = item.name;
    return /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      className: classes.item,
      key: item.id
    }, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
      className: classes.labelWrapper,
      display: "flex",
      alignItems: "center"
    }, _icons["default"][item.type], /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      color: "textSecondary",
      variant: "caption"
    }, item.name)), isPlaceholder ? null : item.type === "linkToRecord" ? /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, Array.isArray(value) ? "".concat(value.length, " ").concat(value.length > 1 ? " records" : " record") : "") : Format ? /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      variant: "body2"
    }, /*#__PURE__*/_react["default"].createElement(Format, {
      row: data,
      column: item,
      onRowChange: function onRowChange() {}
    })) : /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
      className: classes.value,
      variant: "body2"
    }, value));
  })));
}